<template>
    <div class="container">
        <h1>Contact {{ $appName }}</h1>
        <div class="row justify-content-center" v-loading="sendingMessage">
            <div class="col-24">
                <el-form size="large" :model="person" inline :rules="personFormRules" ref="personForm">
                    <el-form-item prop="email">
                        <el-input v-model="person.email" placeholder="E-Mail Address" :disabled="!!userinfo || messageSent"><template #prepend>E-Mail Address</template></el-input>
                    </el-form-item>
                    <el-form-item prop="first_name">
                        <el-input v-model="person.first_name" placeholder="First Name" :disabled="!!userinfo || messageSent"><template #prepend>First Name</template></el-input>
                    </el-form-item>
                    <el-form-item prop="last_name">
                        <el-input v-model="person.last_name" placeholder="Last Name" :disabled="!!userinfo || messageSent"><template #prepend>Last Name</template></el-input>
                    </el-form-item>
                </el-form>
                <el-form size="large" :model="contact" :rules="messageFormRules" ref="messageForm">
                    <el-form-item prop="subject">
                        <el-input v-model="contact.subject" placeholder="Subject" :disabled="messageSent"><template #prepend>Subject</template></el-input>
                    </el-form-item>
                    <el-form-item prop="message">
                        <el-input v-model="contact.message" type="textarea" :rows="5" placeholder="Message" :disabled="messageSent"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="Finished" :disabled="!canSendMessage" :type="messageSent ? 'success' : 'primary'" @click="sendMessage">Send Message</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="col-24 col-md-12" v-if="messageSent">
                <el-result icon="success" title="Message sent" :sub-title="`Thank you for reaching us. Your message was successfully sent to the ${$appName} team. A copy of the message was sent to your e-mail address as well.`"></el-result>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/lib/api'

export default {
    name: 'ContactPage',
    head: {
        title: 'Contact'
    },
    data: () => {
        return {
            person: {
                email: undefined,
                first_name: undefined,
                last_name: undefined
            },
            contact: {
                subject: undefined,
                message: undefined
            },
            personFormValid: false,
            personFormRules: {
                email: { type: 'string', required: true, trigger: 'change', message: 'Email is required' },
                first_name: { type: 'string', required: true, trigger: 'change' },
                last_name: { type: 'string', required: true, trigger: 'change' }
            },
            messageFormValid: false,
            messageFormRules: {
                subject: { type: 'string', required: true, trigger: 'change' },
                message: { type: 'string', required: true, trigger: 'change' }
            },
            sendingMessage: false,
            messageSent: false
        }
    },
    computed: {
        ...mapGetters('auth', ['userinfo']),

        formsValid () {
            return this.personFormValid && this.messageFormValid
        },

        canSendMessage () {
            return !this.sendingMessage && !this.messageSent
        }
    },
    methods: {
        async validateForms () {
            try {
                this.personFormValid = await this.$refs.personForm.validate()
            } catch {
                this.personFormValid = false
            }

            try {
                this.messageFormValid = await this.$refs.messageForm.validate()
            } catch {
                this.messageFormValid = false
            }
        },
        async sendMessage () {
            this.sendingMessage = true

            await this.validateForms()
            if (!this.formsValid) {
                this.sendingMessage = false
                return
            }

            api.contact.sendMessage ({...this.person, ...this.contact}).then(() => {
                this.messageSent = true
                this.$notify({
                    title: 'Success',
                    message: `Your message was sent successfully`,
                    type: 'success'
                })
            }).catch(error => {
                this.errorSendingMessage = true
                const err = error?.response?.data?.message || error.message

                this.$notify({
                    title: 'Error',
                    message: `Could not send your message: ${err}`,
                    type: 'error'
                })
            }).finally (() => {this.sendingMessage = false})
        }
    },
    async mounted () {
        if (this.userinfo) {
            this.person = this.userinfo
        }

        if (this.$route.query.subject) {
            this.contact.subject = this.$route.query.subject
        }
    }
}
</script>